/**
 * Map pathname to page title for the V2 header (used on all pages).
 */
const TITLE_MAP = {
  "/welcome": "Home",
  "/dashboard": "Dashboard",
  "/profile": "Profile",
  "/qr-generate": "QR Code",
  "/manage-banner": "Manage Banner",
  "/merchant-profile": "User",
  "/admin-list": "View Admin",
  "/admin-register": "Add Admin",
  "/admin-edit": "Edit Admin",
  "/manage-admin": "Manage Admin",
  "/distributor-list": "Manage Distributor",
  "/manage-permission": "Manage Permission",
  "/permission-management": "Permission Management",
  "/role-management": "Role Management",
  "/merchant/ncmc_user/list": "NCMC User",
  "/merchant/individual/list": "Individual User",
  "/merchant/business/list": "Business User",
  "merchant/basic_user/list": "Min Kyc User",
  "/merchant-detail": "User Profile",
  "/manage-card": "Manage Card",
  "/manage-card/list": "Manage Card - Assign Cards",
  "/manage-card/physical-card": "Manage Card - Manage Physical Card",
  "/manage-card/virtual-card": "Manage Card - Manage Virtual Card",
  "/manage-card/orders": "Manage Card - Manage Order List",
  "/manage-card/physical-inventory": "Manage Card - Physical Inventory",
  "/manage-card/virtual-inventory": "Manage Card - Virtual Inventory",
  "/card-management": "Card Product Management",
  "/org-card-management": "Org Card Product Management",
  "/manage-soundbox/orders": "Manage SoundBox Order",
  "/transactions": "Transactions",
  "/reports": "Manage Reports",
  "/reports-by-transaction": "Reports By Transaction",
  "/daily-reports": "Daily Reports",
  "/hold_balance_reports": "Hold Balance Reports",
  "/org_hold_balance_reports": "Org Hold Balance Reports",
  "/main_reports": "Main Report",
  "/email_reports": "Email Reports",
  "/org_settelement_reports": "Org Settlement Reports",
  "/org_transaction_reports": "Org Transaction Reports",
  "/settlement_reports": "Settlement Reports",
  "/transaction_reports": "Transaction Reports",
  "/upi_reports": "UPI Reports",
  "/reconcile/request-list": "Reconcile Collect",
  "/reconcile-collect/add": "Add Payment",
  "/reconcile/approval-user-list": "Approval User List",
  "/reconcile/add-approval-user": "Add Approval User",
  "/manage-notification": "Manage Notification",
  "/list-notification": "Notification List",
  "/send-notification": "Send Notifications",
  "/manage-tickets": "Ticket Management",
  "/support": "Help & Support",
  "/manage-operators": "Manage Operator",
  "/login-history": "Login History",
  "/change-password": "Change Password",
  "/payment-settings": "Payment Settings",
  "/banner/list": "Banner",
  "/banner/create": "Upload Banner",
  "/payback": "Payback",
  "/add/payback": "Add Payback",
  "/payback/request-list": "Payback Request List",
  "/payback/approval-user-list": "Approval User List",
  "/payback/add-approval-user": "Add Approval User",
  "/society-partner-hub": "Organization Hub",
  "/society-partner": "Society partner",
  "/program-manager": "Program manager",
  "/society-partner-details": "Society partner details",
};

/**
 * Get page title from pathname. Uses exact match first, then prefix match, then formats path.
 */
export function getPageTitle(pathname) {
  if (TITLE_MAP[pathname]) return TITLE_MAP[pathname];
  // Dynamic routes: /admin-edit/:id -> Edit Admin (no ID in title)
  if (pathname.startsWith("/admin-edit/")) return TITLE_MAP["/admin-edit"] ?? "Edit Admin";
  if (pathname.startsWith("/edit-operator/")) return "Edit Operator";
  if (pathname.startsWith("/banner/update/")) return "Update Banner";
  if (pathname.startsWith("/user-list/")) return "Beneficiary Users";
  if (pathname.startsWith("/payback/edit-approval-user/")) return "Edit Approval User";
  if (pathname.startsWith("/reconcile/edit-approval-user/")) return "Edit Approval User";
  if (pathname.startsWith("/society-partner-hub/")) return "Organization";
  // Prefix match for nested routes (e.g. /payment-settings/add -> Payment Settings)
  const base = pathname.split("/").slice(1, 3).join("/");
  const withLeading = "/" + base;
  if (TITLE_MAP[withLeading]) return TITLE_MAP[withLeading];
  // Format path: /some-path -> Some Path
  const segments = pathname.replace(/^\//, "").split("/").filter(Boolean);
  if (segments.length === 0) return "Dashboard";
  return segments
    .map((s) => s.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()))
    .join(" / ");
}
